
<div class="content-header">New Users</div>
<div class="header-helper">
  New users have been sent an email to complete the new account process. Invited users should accept their invitation
  using the link provided in the email within 72 hours; Expired means that the link has expired, and a new invitation needs to be sent.
  Use the Resend action and select user(s).
</div>

<div class="content content-with-elevation">
  <div class="grid-x" *ngFor="let user of unverifiedUsers">
    <div class="cell large-4 small-12 medium-6">
      <a class="a-link">{{user.firstName}} {{user.lastName}}</a> <span class="header-helper" style="margin-left: 8px">{{user.email}}</span>
    </div>
    <div class="cell large-1 medium-0 small-0"></div>

    <div class="cell large-5 small-12 medium-6">
      {{user.status | titlecase}}
    </div>
  </div>
</div>
